import { render } from "./rikisha-grid.vue?vue&type=template&id=4493ed43&scoped=true"
import script from "./rikisha-grid.vue?vue&type=script&lang=js"
export * from "./rikisha-grid.vue?vue&type=script&lang=js"

import "./rikisha-grid.vue?vue&type=style&index=0&id=4493ed43&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4493ed43"]])

export default __exports__